import React, { useState, useEffect } from 'react';
import BasicCard from "../../../components/basics/cards/BasicCard"
import FilterSettings from '../../../components/FilterSettings'


import DownloadScenarios from './DownloadScenarios'
import ScenarioListing from './ScenarioListing'
import ManageLocalScenario from './ManageLocalScenario'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { ScenarioAPIService } from '../../../services/apis/ScenarioAPIService';
import { ErrorService } from '../../../services/ErrorService';
export default function Scenarios() {
    const controllerName = "Scenario";
    
    const [updatingFilter, setUpdatingFilter] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState("");
    
    const [pageConfig, setPageConfig] = useState({
        pageSettings: { name: "Scenario" },
        controllerName: controllerName,
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: "/"
    });
    
    const [filterArray, setFilterArray] = useState(0);
    const [periodId, setPeriodId] = useState(-1);
    const [nodeId, setNodeId] = useState(-1);
    const [currencyId, setCurrencyId] = useState(-1);
    const [scenarioSelection, setScenarioSelection] = useState([]);

    useEffect(() => {
        const selectedPeriodId = filterArray ? filterArray[0].value : 0
        setPeriodId(selectedPeriodId)

        const selectedCurrencyId = filterArray ? filterArray[2].value : 0
        setCurrencyId(selectedCurrencyId)

        const selectedNodeId = filterArray ? filterArray[1].value : 0
        if (nodeId !== selectedNodeId && selectedNodeId !== 0) {
            setScenarioSelection([]);
            setUpdatingFilter(true);
            setIsLoading(true);

            ScenarioAPIService.searchScenarios(selectedNodeId)
                .then(data => {
                    setIsLoading(false);
                    setNodeId(selectedNodeId)
                    setUpdatingFilter(false)

                    if (data.error) {
                        setError(ErrorService.getErrorMessage(data.error.status));
                    }
                    else {
                        setScenarioSelection(data)
                        setError(false)
                    }
                })
        }
    }, [filterArray])
 
    return (
        <BasicCard cardConfig={{ cardTitle: 'Scenarios', cardHeadingElement: 'h4' }}>
            <FilterSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} />            
            <BasicCard cardConfig={{ cardTitle: '', cardHeadingElement: 'h4' }}>
                <Tabs defaultActiveKey='create-Edit-local-scenario' id='scenarios-actions' className='mb-3'>
                    <Tab eventKey='download-scenario' title='Download scenario'>
                        {<DownloadScenarios scenarioSelection={scenarioSelection} filterArray={filterArray} />}
                    </Tab>
                    <Tab eventKey='create-Edit-local-scenario' title='Create/Edit local scenario'>
                        {<ScenarioListing scenarioSelection={scenarioSelection} setScenarioSelection={setScenarioSelection} isLoading={isLoading} error={error} filterArray={filterArray} />}
                    </Tab>
                    <Tab eventKey='manage-local-scenario' title='Manage local scenario'>
                        {<ManageLocalScenario filterArray={filterArray} setUpdatingFilter={setUpdatingFilter} />}
                    </Tab>
                </Tabs>
            </BasicCard>
        </BasicCard>
    )
}